function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1{stroke-miterlimit:8;stroke-width:3px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, React.createElement("ellipse", {
  className: "cls-1",
  cx: 113.59,
  cy: 133.68,
  rx: 17.75,
  ry: 18.21
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 15.9,
  cy: 62.39,
  rx: 14.4,
  ry: 14.78
}), React.createElement("ellipse", {
  className: "cls-1",
  cx: 99.03,
  cy: 11.49,
  rx: 9.73,
  ry: 9.99
})));

var SvgCellfinateDensidadBaja = function SvgCellfinateDensidadBaja(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 132.84 153.4",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCellfinateDensidadBaja, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cellfinate_densidad_baja.10fc67f4.svg";
export { ForwardRef as ReactComponent };